import EventEmitter from "eventemitter3";

import firebase from "./firebase";

const loginStatusEmitter = new EventEmitter();

export const LoginStatus = {
    Pending: "PENDING",
    LoginError: "LOGIN_ERROR",
    LoggedIn: "LOGGED_IN",
    LoggedOut: "LOGGED_OUT"
};

const state = {
    loginStatus: LoginStatus.Pending,
    loginError: null
};

function changeLoginState(loginStatus, loginError) {
    state.loginStatus = loginStatus;
    state.loginError = loginError;
    loginStatusEmitter.emit("change", state.loginStatus, state.loginError);
}

(async () => {
    firebase.auth().onAuthStateChanged(user => {
        if (user && !user.email.includes("@mondora.com")) {
            changeLoginState(
                LoginStatus.LoginError,
                "Puoi accedere solo con un'utenza :M"
            );
        } else {
            changeLoginState(
                user ? LoginStatus.LoggedIn : LoginStatus.LoggedOut
            );
        }
    });
    try {
        await firebase.auth().getRedirectResult();
    } catch (err) {
        changeLoginState(LoginStatus.LoginError, err.message);
    }
})();

export function getLoginState() {
    return { ...state };
}

export function getCurrentUser() {
    return firebase.auth().currentUser;
}

export function onLoginStatusChange(fn) {
    loginStatusEmitter.on("change", fn);
}
export function offLoginStatusChange(fn) {
    loginStatusEmitter.off("change", fn);
}

export function login() {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithRedirect(provider);
}

export function logout() {
    firebase.auth().signOut();
    changeLoginState(LoginStatus.LoggedOut);
}



// WEBPACK FOOTER //
// ./src/common/authService.js